import { ArrowRight, Mic, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { AppShell } from '../components/AppShell.js';

export function HomePage() {
  return (
    <AppShell language="en">
      <section className="home-hero">
        <div>
          <h1>Report a lost item quickly, without creating an account</h1>
          <p>Scan the QR code provided by the hotel or venue to start a secure lost-item report.</p>
          {import.meta.env.DEV ? (
            <Link className="button button-primary" to="/v/dev-invitation">
              Open local invitation <ArrowRight size={18} />
            </Link>
          ) : null}
        </div>
        <div className="home-points" aria-label="Application features">
          <div>
            <Mic />
            <span>
              <strong>Voice or text</strong>
              <small>Choose the option that works best for you</small>
            </span>
          </div>
          <div>
            <ShieldCheck />
            <span>
              <strong>Privacy first</strong>
              <small>Your audio is never stored by Refindi</small>
            </span>
          </div>
        </div>
      </section>
    </AppShell>
  );
}
